/* global window */
'use strict';
const ApiActions = require('../../../actions/api');
const Constants = require('./constants');
const ForgotStore = require('./forgot/store');
const LoginStore = require('./home/store');
const LogoutStore = require('./logout/store');
const Qs = require('qs');
const ResetStore = require('./reset/store');

class Actions {
    static forgot(data, callback) {
        ApiActions.post(
            '/api/login/forgot',
            data,
            ForgotStore,
            Constants.FORGOT,
            Constants.FORGOT_RESPONSE,
            (err, response) => {
                if (callback) {
                    callback(err && response, response);
                }
            }
        );
    }

    static getUserCreds() {
        if (!global.window) {
            return;
        }

        ApiActions.get(
            '/api/users/my',
            undefined,
            LoginStore,
            Constants.GET_USER_CREDS,
            Constants.GET_USER_CREDS_RESPONSE,
            (err, response) => {
                if (!err) {
                    setTimeout(() => {
                        const query = Qs.parse(window.location.search.substring(1));

                        if (response && response.forceURI) {
                            window.location.href = response.forceURI;
                        } else if (query.returnUrl) {
                            window.location.href = query.returnUrl;
                        } else {
                            window.location.href = window.appPath;
                        }
                    });
                }
            }
        );
    }

    static login(data, callback) {

        ApiActions.post(
            '/api/login',
            data,
            LoginStore,
            Constants.LOGIN,
            Constants.LOGIN_RESPONSE,
            (err, response) => {

                if (callback) {
                    callback(err ? response : null, response);
                }

                if (err && response && response.forceURI) {
                    return window.location.href = response.forceURI;
                }

                if (!err) {
                    setTimeout(() => {
                        const query = Qs.parse(window.location.search.substring(1));
                        let nextUri = window.appPath;

                        if (query.returnUrl) {
                            nextUri = query.returnUrl;
                        } else if (response.returnUrl) {
                            nextUri = response.returnUrl;
                        }

                        if (response.forceURI) {
                            const url = `${ response.forceURI }${ response.forceURI.indexOf('?') > -1 ? '' : `?redirect=${ nextUri }` }`;
                            window.location.href = url;
                        } else {
                            window.location.href = nextUri
                        }
                    })


                }
            }
        )
    }

    static logout(callback) {

        ApiActions.delete(
            '/api/logout',
            undefined,
            LogoutStore,
            Constants.LOGOUT,
            Constants.LOGOUT_RESPONSE,
            (err, response) => {
                if (callback) {
                    callback(err, response);
                }
            }
        );
    }

    static reset(data, callback) {

        ApiActions.post(
            '/api/login/reset',
            data,
            ResetStore,
            Constants.RESET,
            Constants.RESET_RESPONSE,
            (err, response) => {
                if (callback) {
                    callback(err && response ? response : err, response);
                }
            }
        );
    }

    static clearSuccess() {
        ForgotStore.dispatch({
            type: Constants.CLEAR,
        });

    }
}


module.exports = Actions;



// WEBPACK FOOTER //
// ./client/pages/main/login/actions.js